import { useEffect, useRef, useState } from "react";
import classnames from "classnames";

const hasFiles = (dataTransfer) =>
  Array.from(dataTransfer?.types ?? []).includes("Files") ||
  dataTransfer?.files?.length > 0;

const FileDropZone = ({
  children,
  className,
  disabled,
  onFilesDrop,
  onDraggingStateChange,
  ...props
}) => {
  const dragDepth = useRef(0);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    onDraggingStateChange?.(isDragging && !disabled);
  }, [isDragging, disabled, onDraggingStateChange]);

  const handleDrag = (event) => {
    if (!hasFiles(event.dataTransfer)) return;

    event.preventDefault();
    event.stopPropagation();

    if (event.type === "dragenter") {
      dragDepth.current += 1;
      setIsDragging(true);
    } else if (event.type === "dragleave") {
      dragDepth.current = Math.max(0, dragDepth.current - 1);
      if (dragDepth.current === 0) setIsDragging(false);
    }

    event.dataTransfer.dropEffect = disabled ? "none" : "copy";
  };

  const handleDrop = (event) => {
    dragDepth.current = 0;
    setIsDragging(false);
    if (!hasFiles(event.dataTransfer)) return;

    event.preventDefault();
    event.stopPropagation();

    if (!disabled && event.dataTransfer.files?.length > 0)
      onFilesDrop(Array.from(event.dataTransfer.files));
  };

  return (
    <div
      {...props}
      className={classnames(className, {
        "file-drop-zone--dragging": isDragging && !disabled,
      })}
      onDragEnterCapture={handleDrag}
      onDragLeaveCapture={handleDrag}
      onDragOverCapture={handleDrag}
      onDropCapture={handleDrop}
    >
      {children}
    </div>
  );
};

export default FileDropZone;
